<template>
  <perfect-scrollbar id="sidebar" v-if="$session.get(`${$config.appId}_jwt`)">
    <router-link to="/" class="logoCnt">
      <div class="logo"></div>
      CMSRiver<span>by <b>Deepdive Digital</b></span>
    </router-link>

    <div class="user">
      <div class="userPic"></div>
      <p>Welcome</p>
      <h4>{{$session.get(`${$config.appId}_name`) || 'Unknown'}}</h4>
    </div>

    <div class="menuCnt" v-if="!['event_manager', 'event_officer']
      .includes($session.get(`${$config.appId}_role`))">
      <div :class="{menuItem: true, active: title === 'Home'}">
        <router-link to="/" v-on:click.native="$emit('closeSidebar')">
          <img src="../assets/home-icon1.png"> Home
        </router-link>
      </div>
    </div>
    <div class="menuCnt" v-if="!['event_manager', 'event_officer']
      .includes($session.get(`${$config.appId}_role`)) && 1>2">
      <h4>Menu &amp; Pages</h4>
      <div class="menuItem" :class="{active: ['Menu Manager', ''].includes(title)}">
        <router-link to="/config/menu" v-on:click.native="$emit('closeSidebar')">
          <img src="../assets/menu-config.png"> Menu Manager
        </router-link>
        <div class="more" v-on:click.stop="menuMore = 'menuManager'">
          <div class="menuMoreOverlay" v-if="menuMore === 'menuManager'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'menuManager'">
            <li v-on:click.stop="addToHome('menuManager')">Add to Homescreen</li>
          </div>
        </div>
      </div>
    </div>

    <div class="menuCnt" v-if="!['event_manager', 'event_officer']
      .includes($session.get(`${$config.appId}_role`))">
      <h4>Content Directory</h4>
      <div class="menuItemCnt">
        <div class="menuItem" :class="{active: dirId === -1}">
          <router-link to="/content/all" v-on:click.native="$emit('closeSidebar')">
            <img src="../assets/directory.png" class="dir">
            <img src="../assets/directory-open.png" class="dir dirOpen">
            <span>All Contents</span>
          </router-link>
          <div class="more" v-on:click.stop="showMenu = -1">
            <div class="menuMoreOverlay" v-if="showMenu === -1"
              v-on:click.stop="showMenu = null"></div>
            <div class="menuMore" v-on:click="doNothing" v-if="showMenu === -1">
              <li v-on:click.stop="addToHome('allContent')">Add to Homescreen</li>
            </div>
          </div>
        </div>
      </div>
      <div class="menuItemLoading" v-if="loadingMenu"></div>
      <div class="menuItemCnt" v-for="(item, i) in categories" :key="i">
        <div :class="{menuItem: true, active: dirId === item.id,
          hidden: item.visible === 0, eventDir: item.isEventDir}"
          v-on:click.stop="toggleSubmenu(categories, i, item)">
          <router-link :to="`/content/${item.code}?dirId=${item.id}`"
            v-on:click.native="$emit('closeSidebar')">
            <img src="../assets/directory.png" class="dir">
            <img src="../assets/directory-open.png" class="dir dirOpen">
            <span v-if="item.name[lang]">{{item.name[lang]}}</span>
            <span class="noName" v-else>Untitled folder</span>
          </router-link>
          <div class="ddHandle" :class="{open: item.openSubmenu}"
            v-if="item.submenu && item.submenu.length > 0"
            v-on:click.stop="toggleSubmenu(categories, i, item, true)"></div>
          <div class="more" v-on:click.stop="showMenu = item.id">
            <div class="menuMoreOverlay" v-if="showMenu === item.id"
              v-on:click.stop="showMenu = null"></div>
            <div class="menuMore" v-on:click="doNothing" v-if="showMenu === item.id">
              <li v-on:click.stop="editDirectory(i, item)">Edit Directory</li>
              <li v-on:click.stop="addSubcategory(i, item)">Add Sub Directory</li>
              <li class="divider"></li>
              <li v-on:click.stop="setEventDir(item)"
                v-if="item.isEventDir === 0">Mark as Event Directory</li>
              <li v-on:click.stop="setEventDir(item)"
                v-if="item.isEventDir === 1">Unmark Event Directory</li>
              <li class="divider"></li>
              <li class="lisw">
                <span>Display Share</span>
                <div class="sw sm" :class="{on: item.displayShare}"
                  v-on:click="toggleDisplayShare(item)"></div>
              </li>
              <li class="lisw">
                <span>Display Author</span>
                <div class="sw sm" :class="{on: item.displayAuthor}"
                  v-on:click="toggleDisplayAuthor(item)"></div>
              </li>
              <li class="lisw">
                <span>Display Publish Date</span>
                <div class="sw sm" :class="{on: item.displayPublishDate}"
                  v-on:click="toggleDisplayPublishDate(item)"></div>
              </li>
              <li class="lisw">
                <span>Display Views</span>
                <div class="sw sm" :class="{on: item.displayViews}"
                  v-on:click="toggleDisplayViews(item)"></div>
              </li>
              <li class="lisw">
                <span>Display in Search</span>
                <div class="sw sm" :class="{on: item.enableSearch === 1}"
                  v-on:click="toggleSearch(item)"></div>
              </li>
              <li class="liinput">
                <span>Item per Page</span>
                <input class="field" type="text" placeholder="8"
                  :value="item.itemPerPage" v-on:keydown="itemPerPageKeyDown"
                  v-on:blur="setItemPerPage($event.target.value, item)">
              </li>
              <li class="divider"></li>
              <li v-on:click.stop="addToHome('directory', item)">Add to Homescreen</li>
              <li class="divider"></li>
              <li class="red"
                v-on:click.stop="deleteDirectory(i, item)">Delete Directory</li>
            </div>
          </div>
        </div>
        <div class="submenuCnt" v-if="item.submenu && item.submenu.length > 0"
          :class="{open: item.openSubmenu}">
          <div class="menuItemCnt" v-for="(s, is) in item.submenu" :key="is">
            <div class="menuItem submenu"
              :class="{active: dirId === s.id,
              hidden: s.visible === 0, eventDir: s.isEventDir}"
              v-on:click.stop="toggleSubmenu(item.submenu, is, s)">
              <router-link :to="`/content/${s.code}?dirId=${s.id}`"
                v-on:click.native="$emit('closeSidebar')">
                <img src="../assets/directory.png" class="dir">
                <img src="../assets/directory-open.png" class="dir dirOpen">
                <span v-if="s.name[lang]">{{s.name[lang]}}</span>
                <span class="noName" v-else>Untitled folder</span>
              </router-link>
              <div class="ddHandle" :class="{open: s.openSubmenu}"
                v-if="s.submenu && s.submenu.length > 0"
                v-on:click.stop="toggleSubmenu(item.submenu, is, s, true)"></div>
              <div class="more" v-on:click.stop="showMenu = s.id">
                <div class="menuMoreOverlay" v-if="showMenu === s.id"
                  v-on:click.stop="showMenu = null"></div>
                <div class="menuMore" v-on:click.stop="doNothing" v-if="showMenu === s.id">
                  <li v-on:click.stop="addSubcategory(is, s)">Add Subdirectory</li>
                  <li v-on:click.stop="editSubmenu(is, s, item, i)">Edit Directory</li>
                  <li class="divider"></li>
                  <li v-on:click.stop="setEventDir(s)"
                    v-if="s.isEventDir === 0">Mark as Event Directory</li>
                  <li v-on:click.stop="setEventDir(s)"
                    v-if="s.isEventDir === 1">Unmark Event Directory</li>
                  <li class="divider"></li>
                  <li class="lisw">
                    <span>Display Share</span>
                    <div class="sw sm" :class="{on: s.displayShare}"
                      v-on:click="toggleDisplayShare(s)"></div>
                  </li>
                  <li class="lisw">
                    <span>Display Author</span>
                    <div class="sw sm" :class="{on: s.displayAuthor}"
                      v-on:click="toggleDisplayAuthor(s)"></div>
                  </li>
                  <li class="lisw">
                    <span>Display Publish Date</span>
                    <div class="sw sm" :class="{on: s.displayPublishDate}"
                      v-on:click="toggleDisplayPublishDate(s)"></div>
                  </li>
                  <li class="lisw">
                    <span>Display Views</span>
                    <div class="sw sm" :class="{on: s.displayViews}"
                      v-on:click="toggleDisplayViews(s)"></div>
                  </li>
                  <li class="lisw">
                    <span>Display in Search</span>
                    <div class="sw sm" :class="{on: s.enableSearch === 1}"
                      v-on:click="toggleSearch(s)"></div>
                  </li>
                  <li class="liinput">
                    <span>Item per Page</span>
                    <input class="field" type="text" placeholder="8"
                      :value="s.itemPerPage" v-on:keydown="itemPerPageKeyDown"
                      v-on:blur="setItemPerPage($event.target.value, s)">
                  </li>
                  <li class="divider"></li>
                  <li v-on:click.stop="addToHome('directory', s)">Add to Homescreen</li>
                  <li class="divider"></li>
                  <li class="red"
                    v-on:click.stop="deleteSubmenu(is, s, item, i)">Delete Directory</li>
                </div>
              </div>
            </div>
            <div class="submenuCnt" v-if="s.submenu && s.submenu.length > 0"
              :class="{open: s.openSubmenu}">
              <div class="menuItemCnt" v-for="(s2, is2) in s.submenu" :key="is2">
                <div class="menuItem submenu"
                  :class="{active: dirId === s2.id,
                  hidden: s2.visible === 0, eventDir: s2.isEventDir}"
                  v-on:click.stop="toggleSubmenu(s.submenu, is2, s2)">
                  <router-link :to="`/content/${s2.code}?dirId=${s2.id}`"
                    v-on:click.native="$emit('closeSidebar')">
                    <img src="../assets/directory.png" class="dir">
                    <img src="../assets/directory-open.png" class="dir dirOpen">
                    <span v-if="s2.name[lang]">{{s2.name[lang]}}</span>
                    <span class="noName" v-else>Untitled folder</span>
                  </router-link>
                  <div class="ddHandle" :class="{open: s2.openSubmenu}"
                    v-if="s2.submenu && s2.submenu.length > 0"
                    v-on:click.stop="toggleSubmenu(s.submenu, is2, s2, true)"></div>
                  <div class="more" v-on:click="showMenu = s2.id">
                    <div class="menuMoreOverlay" v-if="showMenu === s2.id"
                      v-on:click.stop="showMenu = null"></div>
                    <div class="menuMore" v-on:click="doNothing" v-if="showMenu === s2.id">
                      <li v-on:click.stop="addSubcategory(is2, s2)">Add Subdirectory</li>
                      <li v-on:click.stop="editSubmenu(is2, s2, s, is)">Edit Directory</li>
                      <li class="divider"></li>
                      <li v-on:click.stop="setEventDir(s2)"
                        v-if="s2.isEventDir === 0">Mark as Event Directory</li>
                      <li v-on:click.stop="setEventDir(s2)"
                        v-if="s2.isEventDir === 1">Unmark Event Directory</li>
                      <li class="divider"></li>
                      <li class="lisw">
                        <span>Display Share</span>
                        <div class="sw sm" :class="{on: s2.displayShare}"
                          v-on:click="toggleDisplayShare(s2)"></div>
                      </li>
                      <li class="lisw">
                        <span>Display Author</span>
                        <div class="sw sm" :class="{on: s2.displayAuthor}"
                          v-on:click="toggleDisplayAuthor(s2)"></div>
                      </li>
                      <li class="lisw">
                        <span>Display Publish Date</span>
                        <div class="sw sm" :class="{on: s2.displayPublishDate}"
                          v-on:click="toggleDisplayPublishDate(s2)"></div>
                      </li>
                      <li class="lisw">
                        <span>Display Views</span>
                        <div class="sw sm" :class="{on: s2.displayViews}"
                          v-on:click="toggleDisplayViews(s2)"></div>
                      </li>
                      <li class="lisw">
                        <span>Display in Search</span>
                        <div class="sw sm" :class="{on: s2.enableSearch === 1}"
                          v-on:click="toggleSearch(s2)"></div>
                      </li>
                      <li class="liinput">
                        <span>Item per Page</span>
                        <input class="field" type="text" placeholder="8"
                          :value="s2.itemPerPage" v-on:keydown="itemPerPageKeyDown"
                          v-on:blur="setItemPerPage($event.target.value, s2)">
                      </li>
                      <li class="divider"></li>
                      <li v-on:click.stop="addToHome('directory', s2)">Add to Homescreen</li>
                      <li class="divider"></li>
                      <li class="red"
                        v-on:click.stop="deleteSubmenu(is2, s2, s, is)">Delete Directory</li>
                    </div>
                  </div>
                </div>
                <div class="submenuCnt" v-if="s2.submenu && s2.submenu.length > 0"
                  :class="{open: s2.openSubmenu}">
                  <div class="menuItemCnt" v-for="(s3, is3) in s2.submenu" :key="is3">
                    <div class="menuItem submenu"
                      :class="{active: dirId === s3.id,
                      hidden: s3.visible === 0, eventDir: s3.isEventDir}"
                      v-on:click.stop="toggleSubmenu(s2.submenu, is3, s3)">
                      <router-link :to="`/content/${s3.code}?dirId=${s3.id}`"
                        v-on:click.native="$emit('closeSidebar')">
                        <img src="../assets/directory.png" class="dir">
                        <img src="../assets/directory-open.png" class="dir dirOpen">
                        <span v-if="s3.name[lang]">{{s3.name[lang]}}</span>
                        <span class="noName" v-else>Untitled folder</span>
                      </router-link>
                      <div class="ddHandle" :class="{open: s3.openSubmenu}"
                        v-if="s3.submenu && s3.submenu.length > 0"
                        v-on:click.stop="toggleSubmenu(s2.submenu, is3, s3, true)"></div>
                      <div class="more" v-on:click="showMenu = s3.id">
                        <div class="menuMoreOverlay" v-if="showMenu === s3.id"
                          v-on:click.stop="showMenu = null"></div>
                        <div class="menuMore" v-on:click="doNothing" v-if="showMenu === s3.id">
                          <li v-on:click.stop="addSubcategory(is3, s3)">Add Subdirectory</li>
                          <li v-on:click.stop="editSubmenu(is3, s3, s2, is2)">Edit Directory</li>
                          <li class="divider"></li>
                          <li v-on:click.stop="setEventDir(s3)"
                            v-if="s3.isEventDir === 0">Mark as Event Directory</li>
                          <li v-on:click.stop="setEventDir(s3)"
                            v-if="s3.isEventDir === 1">Unmark Event Directory</li>
                          <li class="divider"></li>
                          <li class="lisw">
                            <span>Display Share</span>
                            <div class="sw sm" :class="{on: s3.displayShare}"
                              v-on:click="toggleDisplayShare(s3)"></div>
                          </li>
                          <li class="lisw">
                            <span>Display Author</span>
                            <div class="sw sm" :class="{on: s3.displayAuthor}"
                              v-on:click="toggleDisplayAuthor(s3)"></div>
                          </li>
                          <li class="lisw">
                            <span>Display Publish Date</span>
                            <div class="sw sm" :class="{on: s3.displayPublishDate}"
                              v-on:click="toggleDisplayPublishDate(s3)"></div>
                          </li>
                          <li class="lisw">
                            <span>Display Views</span>
                            <div class="sw sm" :class="{on: s3.displayViews}"
                              v-on:click="toggleDisplayViews(s3)"></div>
                          </li>
                          <li class="lisw">
                            <span>Display in Search</span>
                            <div class="sw sm" :class="{on: s3.enableSearch === 1}"
                              v-on:click="toggleSearch(s3)"></div>
                          </li>
                          <li class="liinput">
                            <span>Item per Page</span>
                            <input class="field" type="text" placeholder="8"
                              :value="s3.itemPerPage" v-on:keydown="itemPerPageKeyDown"
                              v-on:blur="setItemPerPage($event.target.value, s3)">
                          </li>
                          <li class="divider"></li>
                          <li v-on:click.stop="addToHome('directory', s3)">Add to Homescreen</li>
                          <li class="divider"></li>
                          <li class="red"
                            v-on:click.stop="deleteSubmenu(is3, s3, s2, is2)">Delete Directory</li>
                        </div>
                      </div>
                    </div>
                    <div class="submenuCnt" v-if="s3.submenu && s3.submenu.length > 0"
                      :class="{open: s3.openSubmenu}">
                      <div class="menuItemCnt" v-for="(s4, is4) in s3.submenu" :key="is4">
                        <div class="menuItem submenu"
                          :class="{active: dirId === s4.id,
                          hidden: s4.visible === 0, eventDir: s4.isEventDir}"
                          v-on:click.stop="toggleSubmenu(s3.submenu, is4, s4)">
                          <router-link :to="`/content/${s4.code}?dirId=${s4.id}`"
                            v-on:click.native="$emit('closeSidebar')">
                            <img src="../assets/directory.png" class="dir">
                            <img src="../assets/directory-open.png" class="dir dirOpen">
                            <span v-if="s4.name[lang]">{{s4.name[lang]}}</span>
                            <span class="noName" v-else>Untitled folder</span>
                          </router-link>
                          <div class="ddHandle" :class="{open: s4.openSubmenu}"
                            v-if="s4.submenu && s4.submenu.length > 0"
                            v-on:click.stop="toggleSubmenu(s2.submenu, is3, s3, true)"></div>
                          <div class="more" v-on:click="showMenu = s4.id">
                            <div class="menuMoreOverlay" v-if="showMenu === s4.id"
                              v-on:click.stop="showMenu = null"></div>
                            <div class="menuMore" v-on:click="doNothing" v-if="showMenu === s4.id">
                              <li v-on:click.stop="addSubcategory(is4, s4)"
                                v-if="1>2">Add Subdirectory</li>
                              <li v-on:click.stop="editSubmenu(is4, s4, s3, is3)">
                                Edit Directory</li>
                              <li class="divider"></li>
                              <li v-on:click.stop="setEventDir(s4)"
                                v-if="s4.isEventDir === 0">Mark as Event Directory</li>
                              <li v-on:click.stop="setEventDir(s4)"
                                v-if="s4.isEventDir === 1">Unmark Event Directory</li>
                              <li class="divider"></li>
                              <li class="lisw">
                                <span>Display Share</span>
                                <div class="sw sm" :class="{on: s4.displayShare}"
                                  v-on:click="toggleDisplayShare(s4)"></div>
                              </li>
                              <li class="lisw">
                                <span>Display Author</span>
                                <div class="sw sm" :class="{on: s4.displayAuthor}"
                                  v-on:click="toggleDisplayAuthor(s4)"></div>
                              </li>
                              <li class="lisw">
                                <span>Display Publish Date</span>
                                <div class="sw sm" :class="{on: s4.displayPublishDate}"
                                  v-on:click="toggleDisplayPublishDate(s4)"></div>
                              </li>
                              <li class="lisw">
                                <span>Display Views</span>
                                <div class="sw sm" :class="{on: s4.displayViews}"
                                  v-on:click="toggleDisplayViews(s4)"></div>
                              </li>
                              <li class="lisw">
                                <span>Display in Search</span>
                                <div class="sw sm" :class="{on: s4.enableSearch === 1}"
                                  v-on:click="toggleSearch(s4)"></div>
                              </li>
                              <li class="liinput">
                                <span>Item per Page</span>
                                <input class="field" type="text" placeholder="8"
                                  :value="s4.itemPerPage" v-on:keydown="itemPerPageKeyDown"
                                  v-on:blur="setItemPerPage($event.target.value, s4)">
                              </li>
                              <li class="divider"></li>
                              <li v-on:click.stop="addToHome('directory', s4)">
                                Add to Homescreen</li>
                              <li class="divider"></li>
                              <li class="red"
                                v-on:click.stop="deleteSubmenu(is4, s4, s3, is3)">
                                Delete Directory</li>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="addArticle" v-on:click="addDirectory">
        <img src="../assets/listing-add-black.png">
        New Directory
      </button>
    </div>

    <div class="menuCnt" v-if="!['event_manager', 'event_officer']
      .includes($session.get(`${$config.appId}_role`))">
      <h4>Media Manager</h4>
      <div class="menuItem" :class="{active: title === 'Media Manager'}">
        <router-link to="/media/all" v-on:click.native="$emit('closeSidebar')">
          <img src="../assets/image-black.png"> Media Manager
        </router-link>
        <div class="more" v-on:click.stop="menuMore = 'mediaManager'">
          <div class="menuMoreOverlay" v-if="menuMore === 'mediaManager'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'mediaManager'">
            <li v-on:click.stop="addToHome('mediaManager')">Add to Homescreen</li>
          </div>
        </div>
      </div>
      <div class="menuItem">
        <div class="menuItemLabel" v-on:click.prevent="addYt">
          <img src="../assets/youtube.png"> Add Youtube Video
        </div>
        <div class="more" v-on:click.stop="menuMore = 'addYoutube'">
          <div class="menuMoreOverlay" v-if="menuMore === 'addYoutube'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'addYoutube'">
            <li v-on:click.stop="addToHome('addYoutube')">Add to Homescreen</li>
          </div>
        </div>
      </div>
      <div class="menuItem">
        <div class="menuItemLabel" v-on:click.prevent="upload">
          <img src="../assets/upload-black.png"> Upload Media
        </div>
        <div class="more" v-on:click.stop="menuMore = 'uploadMedia'">
          <div class="menuMoreOverlay" v-if="menuMore === 'uploadMedia'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'uploadMedia'">
            <li v-on:click.stop="addToHome('uploadMedia')">Add to Homescreen</li>
          </div>
        </div>
      </div>
    </div>

    <div class="menuCnt" v-if="!['event_manager', 'event_officer']
      .includes($session.get(`${$config.appId}_role`)) && 1>2">
      <h4>Configurations</h4>
      <div class="menuItem" :class="{active: title === 'Admin'}">
        <router-link to="/users/admin" v-on:click.native="$emit('closeSidebar')">
          <img src="../assets/user-moderator-black.png"> Admin
        </router-link>
        <div class="more" v-on:click.stop="menuMore = 'userAdmin'">
          <div class="menuMoreOverlay" v-if="menuMore === 'userAdmin'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'userAdmin'">
            <li v-on:click.stop="addToHome('userAdmin')">Add to Homescreen</li>
          </div>
        </div>
      </div>
      <div class="menuItem" :class="{active: title === 'Form Submissions'}">
        <router-link to="/subscribers" v-on:click.native="$emit('closeSidebar')">
          <img src="../assets/user3-black.png"> Form Submissions
        </router-link>
        <div class="more" v-on:click.stop="menuMore = 'formSubmissions'">
          <div class="menuMoreOverlay" v-if="menuMore === 'formSubmissions'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'formSubmissions'">
            <li v-on:click.stop="addToHome('formSubmissions')">Add to Homescreen</li>
          </div>
        </div>
      </div>
      <div class="menuItem" :class="{active: title === 'Settings'}">
        <router-link to="/web/config" v-on:click.native="$emit('closeSidebar')">
          <img src="../assets/cog.png"> Settings
        </router-link>
        <div class="more" v-on:click.stop="menuMore = 'webConfig'">
          <div class="menuMoreOverlay" v-if="menuMore === 'webConfig'"
            v-on:click.stop="menuMore = null"></div>
          <div class="menuMore" v-on:click="doNothing"
            v-if="menuMore === 'webConfig'">
            <li v-on:click.stop="addToHome('webConfig')">Add to Homescreen</li>
          </div>
        </div>
      </div>
    </div>

    <div class="about">
      <p><b>Contact:</b>
        <a href="#">hi@cmsriver.com</a>
      <ul>
        <li><a href="#">Term of Use</a></li>
        <li><a href="#">Privacy Policy</a></li>
        <li><a href="#">Copyright</a></li>
      </ul>
      <div class="copyright">&copy; Copyright {{d.getFullYear()}} {{$config.copyright}}</div>
      <div class="poweredBy">
        <h4>Powered by</h4>
        <a href="https://cmsriver.com" target="_blank">
          <div class="logo"></div>
          CMS<span>River</span>
        </a>
      </div>
    </div>
    <AddArticleCategory ref="showInputer"/>
    <MediaUploader ref="mediaUploader"/>
    <Confirmation ref="confirmDialog"/>
    <Snackbar ref="snackbar"/>
    <MediaInputer ref="mediaInputer"/>
    <LoadingDialog ref="loadingDialog"/>
    <FormInputerShort ref="formInputer"/>
  </perfect-scrollbar>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MediaUploader from '@/components/MediaUploader.vue';
import AddArticleCategory from '@/components/AddArticleCategory.vue';
import Confirmation from '@/components/Confirmation.vue';
import Snackbar from '@/components/Snackbar.vue';
import MediaInputer from '@/components/MediaInputer.vue';
import LoadingDialog from '@/components/LoadingDialog.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';

export default {
  name: 'sidebar',
  components: {
    AddArticleCategory,
    MediaUploader,
    Confirmation,
    Snackbar,
    MediaInputer,
    LoadingDialog,
    FormInputerShort,
  },
  data() {
    return {
      loadingMenu: true,
      categories: [],
      showMenu: null,
      d: new Date(),
      trxCount: 0,
      menuMore: null,
    };
  },
  watch: {
    $route(to, from) {
      this.checkActiveDir();
    },
  },
  methods: {
    ...mapActions(['chDirId']),
    doNothing() {},
    toggleDisplayShare(item) {
      if (item.displayShare) {
        this.$refs.confirmDialog.open({
          title: 'Hide Share',
          desc: `Are you sure you want to hide share for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Hide Share',
        }, (b) => {
          if (!b) return;
          item.displayShare = 0; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/Share/0`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      } else {
        this.$refs.confirmDialog.open({
          title: 'Display Share',
          desc: `Are you sure you want to show share for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Show Share',
        }, (b) => {
          if (!b) return;
          item.displayShare = 1; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/Share/1`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      }
    },
    itemPerPageKeyDown(e) {
      if (e.code === 'Enter') e.target.blur();
    },
    setItemPerPage(itemPerPage, item) {
      const ipp = Number(itemPerPage);
      if (!ipp || Number.isNaN(ipp)) return;
      this.$http.get(this.$config.uri(`article/directory/${item.id}/item-per-page/${ipp}`)).then(() => {
        this.$refs.snackbar.open({ content: 'Changes has been saved' });
      });
    },
    toggleDisplayAuthor(item) {
      if (item.displayAuthor) {
        this.$refs.confirmDialog.open({
          title: 'Hide Author',
          desc: `Are you sure you want to hide author for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Hide Author',
        }, (b) => {
          if (!b) return;
          item.displayAuthor = 0; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/author/0`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      } else {
        this.$refs.confirmDialog.open({
          title: 'Display Author',
          desc: `Are you sure you want to show author for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Show Author',
        }, (b) => {
          if (!b) return;
          item.displayAuthor = 1; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/author/1`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      }
    },
    toggleDisplayPublishDate(item) {
      if (item.displayPublishDate) {
        this.$refs.confirmDialog.open({
          title: 'Hide Publish Date',
          desc: `Are you sure you want to hide publish date for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Hide Date',
        }, (b) => {
          if (!b) return;
          item.displayPublishDate = 0; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/publish-date/0`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      } else {
        this.$refs.confirmDialog.open({
          title: 'Display Publish Date',
          desc: `Are you sure you want to show publish date for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Show Date',
        }, (b) => {
          if (!b) return;
          item.displayPublishDate = 1; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/publish-date/1`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      }
    },
    toggleDisplayViews(item) {
      if (item.displayViews) {
        this.$refs.confirmDialog.open({
          title: 'Hide View Count',
          desc: `Are you sure you want to hide view count for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Hide Views',
        }, (b) => {
          if (!b) return;
          item.displayViews = 0; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/views/0`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      } else {
        this.$refs.confirmDialog.open({
          title: 'Display View Count',
          desc: `Are you sure you want to show view count for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Show Views',
        }, (b) => {
          if (!b) return;
          item.displayViews = 1; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/views/1`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      }
    },
    toggleSearch(item) {
      if (item.enableSearch) {
        this.$refs.confirmDialog.open({
          title: 'Hide From Search',
          desc: `Are you sure you want to hide from search for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Hide Search',
        }, (b) => {
          if (!b) return;
          item.enableSearch = 0; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/search/0`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      } else {
        this.$refs.confirmDialog.open({
          title: 'Show On Search',
          desc: `Are you sure you want to show on search for all contents inside this directory?
            All specific configuration of the contents inside this directory will be overwritten.
            Sub Directories and contents inside it will not be affected.`,
          action: 'Show Search',
        }, (b) => {
          if (!b) return;
          item.enableSearch = 1; // eslint-disable-line
          this.$http.get(this.$config.uri(`article/directory/${item.id}/search/1`)).then(() => {
            this.$refs.snackbar.open({ content: 'Changes has been saved' });
          });
        });
      }
    },
    addToHome(menu, item) {
      this.menuMore = null;
      this.showMenu = null;
      let formData;
      if (menu === 'menuManager') {
        formData = {
          type: 'page',
          name: 'Menu Manager',
          code: 'menu_manager',
          uri: '/config/menu',
        };
      } else if (menu === 'allContent') {
        formData = {
          type: 'page',
          name: 'All Contents',
          code: 'all_content',
          uri: '/content/all',
        };
      } else if (menu === 'pageEditor') {
        formData = {
          type: 'page',
          name: 'Page Editor',
          code: 'page_editor',
          uri: '/pages',
        };
      } else if (menu === 'mediaManager') {
        formData = {
          type: 'page',
          name: 'Media Manager',
          code: 'media_manager',
          uri: '/media/all',
        };
      } else if (menu === 'addYoutube') {
        formData = {
          type: 'dialog',
          name: 'Add Youtube Video',
          code: 'add_youtube',
        };
      } else if (menu === 'uploadMedia') {
        formData = {
          type: 'dialog',
          name: 'Upload Media',
          code: 'upload_media',
        };
      } else if (menu === 'webConfig') {
        formData = {
          type: 'page',
          name: 'Settings',
          code: 'web_config',
          uri: '/web/config',
        };
      } else if (menu === 'userAdmin') {
        formData = {
          type: 'page',
          name: 'Admin',
          code: 'user_admin',
          uri: '/users/admin',
        };
      } else if (menu === 'formSubmissions') {
        formData = {
          type: 'page',
          name: 'Form Submissions',
          code: 'form_submissions',
          uri: '/subscribers',
        };
      } else if (menu === 'directory') {
        formData = {
          type: 'directory',
          refId: item.id,
        };
      }
      if (!formData) return;
      this.$http.post(this.$config.uri('misc/home'), formData).then(() => {
        this.$refs.snackbar.open({ content: 'Item added to home screen' });
      });
    },
    toggleSubmenu(menu, i, item, fromHandle) {
      if (item.openSubmenu) {
        if (fromHandle) {
          // eslint-disable-next-line
          item.openSubmenu = false;
        }
        return;
      }
      // eslint-disable-next-line
      for (const cat of menu) {
        cat.openSubmenu = (item.id === cat.id);
      }
    },
    setEventDir(item) {
      this.showMenu = null;
      let cTitle = '';
      let cDesc = '';
      if (item.isEventDir === 1) {
        cTitle = 'Unmark Event Directory';
        cDesc = 'Are you sure you want to mark this directory as normal directory?';
      } else {
        cTitle = 'Mark as Event Directory';
        cDesc = 'Are you sure you want to mark this directory as event directory? '
          + 'This will changes content sort behaviour and add '
          + 'Upcoming and Previous Event button';
      }
      this.$refs.confirmDialog.open({
        title: cTitle,
        desc: cDesc,
        action: 'Update',
      }, (b) => {
        if (!b) return;
        // eslint-disable-next-line
        item.isEventDir = item.isEventDir === 1 ? 0 : 1;
        this.$http.get(this.$config.uri(`article/directory/${item.id}/eventdir/${item.isEventDir}`)).then(() => {
          this.$refs.snackbar.open({ content: 'Directory flag has been updated' });
        });
      });
    },
    deleteSubmenu(i, item, parent, pi) {
      this.showMenu = null;
      const name = item.name[this.lang] || 'Directory';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete this directory? If you not tick delete content
          all content this directory will not be deleted, but will not be accesible.`,
      }, (b) => {
        if (b) this.deleteNowSubmenu(i, item, parent, pi);
      });
    },
    deleteNowSubmenu(i, item, parent, pi) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: 'To prevent from accidentally deleted directory, you need to input your password.',
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Directory',
      }, (b) => {
        if (!b) return;
        // eslint-disable-next-line
        parent.submenu.splice(i, 1);
        this.$http.get(this.$config.uri(`article/directory/${item.id}/delete`)).then((r) => {
          this.$refs.snackbar.open({ content: `Directory ${item.name} has been deleted.` });
        });
      });
    },
    deleteDirectory(i, item) {
      this.showMenu = null;
      const name = item.name[this.lang] || 'Directory';
      this.$refs.confirmDialog.open({
        title: `Delete ${name}`,
        desc: `Are you sure you want to delete this directory? If you not tick delete content
          all content this directory will not be deleted, but will not be accesible.`,
        checkbox: 'Also delete content in this directory',
      }, (b, c) => {
        if (!b) return;
        this.deleteNow(i, item, c);
      });
    },
    deleteNow(i, item, c) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: 'To prevent from accidentally deleted directory, you need to input your password.',
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Menu',
      }, (b) => {
        if (!b) return;
        this.categories.splice(i, 1);
        const cx = (c) ? 'YES' : 'NO';
        this.$http.get(this.$config.uri(`article/directory/${item.id}/delete?content=${cx}`)).then(() => {
          this.$refs.snackbar.open({ content: `Menu ${item.name} has been deleted.` });
        });
      });
    },
    checkActiveDir() {
      let { dirId } = this.$route.query;
      if (dirId) {
        dirId = parseInt(dirId, 10);
        // eslint-disable-next-line
        for (const item of this.categories) {
          if (item.id === dirId) {
            item.openSubmenu = true;
            break;
          }

          // eslint-disable-next-line
          for (const s of item.submenu) {
            if (s.id === dirId) {
              item.openSubmenu = true;
              s.openSubmenu = true;
              break;
            }

            // eslint-disable-next-line
            for (const s2 of s.submenu) {
              if (s2.id === dirId) {
                item.openSubmenu = true;
                s.openSubmenu = true;
                s2.openSubmenu = true;
                break;
              }

              // eslint-disable-next-line
              for (const s3 of s2.submenu) {
                if (s3.id === dirId) {
                  item.openSubmenu = true;
                  s.openSubmenu = true;
                  s2.openSubmenu = true;
                  s3.openSubmenu = true;
                  break;
                }
              }
            }
          }
        }
      }
    },
    getCategories() {
      this.$http.get(this.$config.uri('article/directory')).then((r) => {
        this.loadingMenu = false;
        this.categories = (r.data.status === 200) ? r.data.data : [];

        /**
         * Open submenu for active / selected directory
         *
         */
        this.checkActiveDir();
      });
    },
    editSubmenu(i, item, parent, pi) {
      this.showMenu = null;
      this.$refs.mediaInputer.open({
        title: 'Edit Directory',
        placeholder: 'Directory Name',
        action: 'Save Directory',
        required: true,
        model: item.name,
        multiLang: true,
      }, (b, d) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        const formData = { id: item.id, name: d };
        this.$http.post(this.$config.uri('article/directory'), formData).then((r) => {
          this.$refs.loadingDialog.close();
          // eslint-disable-next-line
          item.name = r.data.data.name;
          // eslint-disable-next-line
          item.code = r.data.data.code;
          this.$refs.snackbar.open({ content: 'Changes has been saved' });
        });
      });
    },
    restartService() {
      this.$emit('closeSidebar');
      this.$refs.confirmDialog.open({
        title: 'Sestart Service',
        desc: 'Are you sure you want to restart API Service? Web will not be accesible in a few seconds',
        action: 'Restart',
      }, (b) => {
        if (!b) return;
        this.$http.get(this.$config.uri('misc/api/restart')).then((r) => {
          this.$refs.snackbar.open({ content: 'API Restart on progress, refresh this page in a few second' });
        });
      });
    },
    addSubcategory(i, item) {
      this.showMenu = null;
      this.$refs.mediaInputer.open({
        title: 'New Sub Directory',
        placeholder: 'Sub Directory Name',
        action: 'Save',
        required: true,
        multiLang: true,
      }, (b, d) => {
        if (!b || !d) return;
        this.$refs.loadingDialog.open();
        const formData = { name: d, parentId: item.id };
        this.$http.post(this.$config.uri('article/directory'), formData).then((r) => {
          this.$refs.loadingDialog.close();
          // eslint-disable-next-line
          if (!item.submenu) item.submenu = [];
          item.submenu.push(r.data.data);
        });
      });
    },
    editDirectory(i, item) {
      this.showMenu = null;
      this.$refs.mediaInputer.open({
        title: 'Edit Directory',
        placeholder: 'Directory Name',
        action: 'Save Directory',
        required: true,
        model: item.name,
        multiLang: true,
      }, (b, d) => {
        if (!b) return;
        this.$refs.loadingDialog.open();
        const formData = { id: item.id, name: d };
        this.$http.post(this.$config.uri('article/directory'), formData).then((r) => {
          this.$refs.loadingDialog.close();
          this.categories[i].name = d.name;
          this.categories[i].slug = d.slug;
        });
      });
    },
    addDirectory() {
      this.$emit('closeSidebar');
      this.$refs.mediaInputer.open({
        title: 'New Directory',
        placeholder: 'Directory Name',
        action: 'Save Directory',
        required: true,
        multiLang: true,
      }, (b, d) => {
        if (!b || !d) return;
        this.$refs.loadingDialog.open();
        const formData = { name: d };
        this.$http.post(this.$config.uri('article/directory'), formData).then((r) => {
          this.$refs.loadingDialog.close();
          this.categories.push(r.data.data);
        });
      });
    },
    upload() {
      this.$emit('closeSidebar');
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaUploader.open(null, (b) => {
        setTimeout(() => {
          document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        }, 200);
        if (!b) return;
        if (this.$route.path !== '/media/all') {
          this.$router.push('/media/all');
        } else {
          window.location.reload();
        }
      });
    },
    validateYouTubeUrl(url) {
      if (!url || url === '') {
        return false;
      }
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=|\?v=)([^#\&\?]*).*/; //eslint-disable-line
      const match = url.match(regExp);
      const videoId = (match && match[2].length === 11) ? match[2] : false;
      return videoId;
    },
    countUnread() {
      this.$http.get(this.$config.uri('misc/trx/unread')).then((r) => {
        this.trxCount = (r.data.status === 200) ? r.data.data : 0;
      });
    },
    addYt() {
      this.$emit('closeSidebar');
      document.getElementsByTagName('BODY')[0].classList.add('selectingMedia');
      this.$refs.mediaInputer.open({
        title: 'Youtube Video Url',
        placeholder: 'Paste youtube video link here...',
        action: 'Insert Video',
      }, (b, uri) => {
        setTimeout(() => {
          document.getElementsByTagName('BODY')[0].classList.remove('selectingMedia');
        }, 200);
        if (!b) return;
        const videoId = this.validateYouTubeUrl(uri);
        if (!videoId) {
          this.$refs.confirmDialog.open({
            title: 'Invalid Video Url',
            desc: `The url for youtube video you input
              is not valid youtube url.`,
            error: true,
          }, () => {});
          return;
        }
        this.$refs.loadingDialog.open();
        this.$http.post(this.$config.uri('media/youtube/add'), { videoId }).then((r) => {
          this.$refs.loadingDialog.close();
          if (this.$route.path !== '/media/all') {
            this.$router.push('/media/all');
          } else {
            window.location.reload();
          }
        });
      });
    },
  },
  computed: {
    ...mapState(['title', 'lang', 'dirId']),
  },
  mounted() {
    this.getCategories();

    /**
     * This for setting menu active in directory
     *
     */
    const { dirId } = this.$route.query;
    if (dirId) this.chDirId(parseInt(dirId, 10));

    // this.$http.get(this.$config.uri('article/parents?static=1')).then((r) => {
    //   this.statics = (r.data.status === 200) ? r.data.data : [];
    // });

    // this.countUnread();
    // if (notifTimer) clearInterval(notifTimer);
    // notifTimer = setInterval(() => {
    //   this.countUnread();
    // }, 10000);
  },
};
</script>

<style lang="scss">
  body.selectingMedia{
    overflow: hidden;
    .formAction{
      display: none;
    }
    .contentHeader{
      display: none;
    }
  }
</style>

<style scoped lang="scss">
  #sidebar{
    // position: relative;
    width: 300px;
    background-color: #0747a6;
    background-color: #fff;
    padding: 10px 30px 20px 30px;
    color: #fff;
    color: #444;
    box-sizing: border-box;
    height: 100vh;
    overflow: auto;
    // z-index: 99;
    border-right: #eee 1px solid;
    @media (max-width: 1460px) {
      width: 260px;
    }
  }

  .about{
    font-size: 13px;
    margin-top: 40px;
    a{
      display: block;
      padding: 1px 0;
      padding-right: 10px;
      color: #fff;
      color: #444;
      opacity: .7;
    }
    a:hover{
      opacity: 1;
    }
    p{
      margin-bottom: 10px;
      b{
        opacity: .6;
      }
    }
    ul{
      margin: 0;
      padding: 0;
      margin-bottom: 10px;
      li{
        list-style20px: none;
        display: inline-block;
      }
    }
    .copyright{
      opacity: .7;
    }
  }

  .logoCnt{
    display: block;
    padding-top: 20px;
    position: relative;
    padding-left: 58px;
    font-size: 18px;
    font-weight: 500;
    height: 50px;
    line-height: 1.2;
    color: #444;
    font-weight: 600;
    span{
      display: block;
      font-weight: 400;
      font-size: 14px;
      b{
        font-weight: 600;
      }
    }
    .logo{
      position: absolute;
      top: 11px;
      left: -4px;
      width: 100%;
      height: 56px;
      background-position: left center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(../assets/logo.png);
      background-size: auto 48px;
      // border-radius: 50%;
    }
  }

  .user{
    padding-top: 30px;
    padding-bottom: 8px;
    position: relative;
    padding-left: 74px;
    .userPic{
      position: absolute;
      top: 30px;
      left: 0;
      background-color: #fff;
      background-color: #eee;
      background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      width: 56px;
      height: 56px;
    }
    p{
      margin: 0;
      opacity: .7;
      padding-top: 5px;
    }
    h4{
      margin: 0;
      font-size: 20px;
      white-space: nowrap;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .newListing{
    margin-top: 40px;
    border: #1270ff 2px solid;
    background-color: #1270ff;
    border-radius: 50px;
    padding: 8px 10px 10px;
    text-align: center;
    font-size: 19px;
    text-transform: uppercase;
    font-weight: 600;
    box-shadow: 2px 2px 8px rgba(0,0,0,.2);
    cursor: pointer;
    display: block;
    color: #fff;
    color: #444;
    img{
      height: 20px;
      margin-bottom: -3px;
      margin-right: 4px;
    }
  }
  .newListing:hover{
    background-color: #015eec;
    border-color: #015eec;
  }

  .menuCnt{
    margin-top: 26px;
    .addArticle{
      color: #fff;
      color: #444;
      background: none;
      border: none;
      cursor: pointer;
      padding: 4px 12px 7px;
      margin: 9px -12px 0;
      display: block;
      width: calc(100% + 24px);
      box-sizing: border-box;
      border-radius: 50px;
      text-align: left;
      outline: 0;
      opacity: .5;
      img{
        height: 20px;
        margin-right: 9px;
        margin-bottom: -5px;
        opacity: .6;
      }
      &:hover{
        background-color: rgba(0,0,0,.1);
        opacity: .9;
        img{
          opacity: .7;
        }
      }
    }
    h4{
      margin: 0;
      color: #999;
      text-transform: uppercase;
      padding-bottom: 8px;
      font-size: 13px;
      font-weight: 600;
    }
    .menuMoreOverlay{
      position: fixed;
      cursor: default;
      left: 0; right: 0; top: 0; bottom: 0;
      z-index: 991;
    }
    .menuItemLoading{
      height: 38px;
      border-radius: 7px;
      background-color: #eee;
      margin: 0 -12px 4px;
      background-image: url(../assets/loading-2.svg);
      background-size: 24px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    .submenuCnt{
      margin-left: 14px;
      margin-bottom: 6px;
      display: none;
      &.open{
        display: block;
      }
      .menuItem{
        border-radius: 50px;
      }
    }
    .menuItem{
      display: block;
      margin: 0 -12px;
      margin-left: -30px;
      padding: 8px 12px;
      padding-left: 30px;
      padding-right: 40px;
      border-radius: 0 50px 50px 0;
      cursor: pointer;
      font-size: 17px;
      color: #fff;
      color: #444;
      margin-bottom: 4px;
      position: relative;
      .menuItemLabel{
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      a{
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .noName{
        color: #999;
        font-style: italic;
      }
      &.eventDir{
        a{
          position: relative;
          &:before{
            content: "";
            position: absolute;
            left: 22px; bottom: 6px;
            background-color: #0e5dd2;
            border-radius: 50%;
            width: 8px; height: 8px;
            border: #fff 2px solid;
            opacity: 1;
            z-index: 3;
          }
        }
        &:hover a:before{
          border-color: #eee;
        }
        &.active a:before{
          border-color: #bdd8ff;
        }
      }
      &.submenu{
        font-size: 16px;
        min-height: 38px;
        box-sizing: border-box;
        .submenuIcon{
          width: 2px; height: 10px;
          background-color: #767676;
          border-radius: 10px;
          position: absolute;
          left: -20px; top: 10px;
          &:before{
            content: "";
            position: absolute;
            left: 0; bottom: 0;
            background-color: #767676;
            border-radius: 10px;
            width: 10px; height: 2px;
          }
        }
        &.hidden{
          &:before{
            left: -23px;
          }
          .submenuIcon{
            opacity: 0;
          }
        }
      }
      &.disabled{
        opacity: .4 !important;
        cursor: default;
        background: none !important;
        img{
          opacity: .6 !important;
        }
      }
      a{
        color: #fff;
        color: #444;
        display: block;
        padding: 8px 12px;
        margin: -8px -12px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        &.feLink{
          padding: 0; margin: 0;
          position: absolute;
          width: 30px; height: 30px;
          right: 38px; top: 4px;
          border-radius: 50%;
          background-size: 18px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-image: url(../assets/external-link-black.png);
          opacity: .5;
          &:hover{
            opacity: .7;
            background-color: rgba(0,0,0,.1);
          }
        }
      }
      .ddHandle{
        padding: 0; margin: 0;
        position: absolute;
        width: 26px; height: 26px;
        left: 4px; top: 50%;
        margin-top: -13px;
        border-radius: 50%;
        background-size: 12px auto;
        background-position: center;
        background-repeat: no-repeat;
        background-image: url(../assets/down-arrow.png);
        transform: rotate(-90deg);
        opacity: .5;
        transition: all .3s ease;
        &.open{
          transform: none;
        }
        &:hover{
          opacity: .7;
          background-color: rgba(0,0,0,.1);
        }
      }
      .more{
        position: absolute;
        width: 30px; height: 30px;
        border-radius: 50%;
        right: 6px; top: 4px;
        transition: all .3s ease;
        &:before{
          content: "";
          position: absolute;
          left: 0; top: 0; right: 0; bottom: 0;
          background-image: url(../assets/more.png);
          background-size: 14px auto;
          background-position: center;
          transition: all .3s ease;
          background-repeat: no-repeat;
          opacity: .5;
        }
        &:hover{
          &:before{
            opacity: .7;
          }
          background-color: #fff;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        }
        &.edit{
          &:before{
            background-image: url(../assets/edit-black.png);
            opacity: .85;
          }
        }
        .menuMore{
          position: absolute;
          right: -8px; top: 100%;
          background-color: #fff;
          z-index: 992;
          padding: 10px 0;
          border-radius: 5px;
          border: #eee 1px solid;
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
          li, a{
            display: block;
            list-style: none;
            font-size: 15px;
            padding: 6px 14px;
            white-space: nowrap;
            margin: 0;
            min-width: 120px;
            &.red{
              color: red;
            }
            &.liinput{
              position: relative;
              display: flex;
              align-items: center;
              span{
                margin-right: auto;
              }
              .field{
                padding: 0;
                padding-right: 6px;
                font-size: 15px;
                text-align: right;
                border: none !important;
                width: 60px;
                box-shadow: none !important;
                background-color: transparent;
              }
            }
            &.lisw{
              position: relative;
              display: flex;
              span{
                margin-right: 10px;
              }
              .sw{
                width: 36px;
                height: 20px;
                background-color: #ccc;
                border: #ccc 1px solid;
                border-radius: 50px;
                margin-left: auto;
                position: relative;
                cursor: pointer;
                transition: all .2s ease;
                &:before{
                  content: "";
                  position: absolute;
                  left: 1px; top: 1px;
                  width: 18px; height: 18px;
                  background-color: #fff;
                  box-shadow: 2px 2px 3px rgba(0,0,0,.1);
                  border-radius: 50%;
                  transition: all .2s ease;
                }
                &.on{
                  background-color: #ec174c;
                  border-color: #ec174c;
                  &:before{
                    left: 17px;
                  }
                }
                &.disabled{
                  background-color: #ccc;
                  border-color: #ccc;
                  cursor: default;
                  &:before{
                    left: 1px;
                    background-color: #ddd;
                    box-shadow: none;
                  }
                }
              }
            }
            &:hover{
              background-color: #f5f5f5;
            }
            &.divider{
              border-top: #eee 1px solid;
              margin-top: 6px;
              padding: 3px 0;
              cursor: default;
              background-color: #fff;
            }
          }
        }
      }
      .ntf{
        position: absolute;
        right: 10px; top: 9px;
        height: 18px; min-width: 18px;
        color: #fff;
        background-color: red;
        text-align: center;
        border-radius: 9px;
        font-size: 13px;
        padding: 0 5px;
      }
      .config{
        position: absolute;
        top: 3px; right: 4px;
        border-radius: 50%;
        width: 30px; height: 30px;
        background-image: url(../assets/settings-black.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: .4;
        display: none;
        &:hover{
          opacity: .8;
        }
      }
      &:hover{
        .config{
          display: block;
        }
      }
      img{
        height: 20px;
        margin-right: 9px;
        margin-bottom: -3px;
        opacity: .6;
        &.ctgr{
          height: 24px;
          margin-right: 7px;
          margin-left: -2px;
          margin-bottom: -5px;
        }
        &.ctgr2{
          height: 22px;
          margin-right: 8px;
          margin-left: -1px;
          margin-bottom: -4px;
        }
        &.dir{
          height: 19px;
          margin-left: 1px;
          &.dirOpen{
            display: none;
          }
        }
      }
      &.hidden{
        img{
          visibility: hidden;
        }
        &:before{
          content: "";
          position: absolute;
          left: 12px; top: 8px;
          width: 20px; height: 20px;
          background-image: url(../assets/eye-closed.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .6;
        }
      }
    }
    .menuItem.active{
      background-color: #bdd8ff !important;
      img{
        opacity: .7;
        &.dir{
          display: none;
          &.dirOpen{
            display: inline-block;
          }
        }
      }
    }
    .menuItem:hover{
      background-color: #eee;
      img{
        opacity: .7;
      }
    }
  }

  .poweredBy{
    font-size: 15px;
    font-weight: lighter;
    padding-top: 10px;
    a{
      padding: 0;
      opacity: 1;
    }
    h4{
      margin: 0;
      opacity: .7;
      font-size: 12px;
      margin-bottom: 4px;
    }
    span{
      font-weight: normal;
    }
    .logo{
      width: 16px;
      height: 16px;
      background-image: url(../assets/cmsriver-logo.png);
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      float: left;
      margin-right: 6px;
      margin-bottom: -5px;
      margin-top: 1px;
    }
  }
</style>
